import { searchTransformations } from '../../../helpers/profileGeneratorHelper';

export async function includeTransformation(
  componentPath: string,
  entityName: string,
): Promise<{
  filePaths: string[];
  associations: {
    taskId: string;
    pullerId: string;
    tableId: string;
    resultKey: string;
  } | null;
} | null> {
  const transformations = (await searchTransformations(
    entityName,
    componentPath,
  )) as any[];

  if (!transformations.length) {
    console.error(
      `Could not find transformation named ${entityName} in ${componentPath}`,
    );
    return null;
  }

  const filePaths = transformations
    .map((t) => t.__file_path)
    .filter(Boolean)
    .filter((v, i, a) => a.indexOf(v) === i);

  return { filePaths, associations: null };
}
